<template>
  <button
    type="button"
    class="auth-login__option"
    :class="{ 'auth-login__option--active': active }"
    :aria-pressed="active ? 'true' : 'false'"
    :disabled="disabled"
    @click="emit('select')"
  >
    <span class="auth-login__option-title">
      <AuthIcon :name="icon" class="auth-login__option-icon" />
      {{ title }}
    </span>
    <p v-if="description" class="auth-login__option-desc">{{ description }}</p>
  </button>
</template>

<script setup>
import AuthIcon from './AuthIcon.vue'

defineProps({
  title:       { type: String, required: true },
  description: { type: String, default: '' },
  icon:        { type: String, default: 'user' },
  active:      { type: Boolean, default: false },
  disabled:    { type: Boolean, default: false },
})

const emit = defineEmits(['select'])
</script>
